import React from 'react';
import PropTypes from 'prop-types';
import './CustomButton.css';

function CustomButton({ icon: Icon, name, baseClass = 'custom-button', hoverClass, activeClass, borders = '', bordersClassPrefix = 'border-orange-', onClick }) {

    // Generowanie klas dla ramek na podstawie borders
    const borderClasses = borders
    .split('')
    .map((char) => `${bordersClassPrefix}${char}`)
    .join(' ');

  return (
    <button
      className={`${baseClass} ${activeClass} ${borderClasses}`}
      onClick={onClick}
      onMouseEnter={(e) => hoverClass && e.currentTarget.classList.add(hoverClass)}
      onMouseLeave={(e) => hoverClass && e.currentTarget.classList.remove(hoverClass)}
    >
      {Icon && <Icon className="button-icon" />}
      <span className="button-name">{name}</span>
    </button>
  );
}

CustomButton.propTypes = {
  icon: PropTypes.elementType, // Komponent ikony
  name: PropTypes.string.isRequired, // Nazwa przycisku
  baseClass: PropTypes.string, // Klasa podstawowego wyglądu (opcjonalna, z domyślną wartością)
  hoverClass: PropTypes.string, // Klasa dla hover (opcjonalna)
  activeClass: PropTypes.string, // Klasa dla stanu aktywnego (opcjonalna)
  borders: PropTypes.string, // Ciąg znaków definiujący ramki (np. "LRBT")
  onClick: PropTypes.func.isRequired, // Funkcja wywoływana po kliknięciu
};

CustomButton.defaultProps = {
  baseClass: 'custom-button', // Domyślna wartość dla baseClass
  borders: '', // Domyślnie brak ramek
  hoverClass: '', // Domyślnie brak klasy hover
  activeClass: '', // Domyślnie brak klasy aktywnej
};

export default CustomButton;